import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { QueueSelect } from 'components/queueSelect';
import { useHookFormFieldWrapper, } from 'utils/hookForm';
/** Represents the React Hook Form variant of the {@link QueueSelect} component. */
export const HookFormQueueSelect = (props) => {
    var _a;
    const { controller, fieldWrapperProps } = useHookFormFieldWrapper(props);
    const [selectedQueue, setSelectedQueue] = useState((_a = props.componentProps) === null || _a === void 0 ? void 0 : _a.selectedQueue);
    useUpdateEffect(() => {
        controller.field.onChange(selectedQueue === null || selectedQueue === void 0 ? void 0 : selectedQueue.id);
    }, [selectedQueue]);
    const handleToggle = useCallback((isOpen) => {
        if (!isOpen) {
            controller.field.onBlur();
        }
    }, [controller.field]);
    return (_jsx(FieldWrapper, Object.assign({}, fieldWrapperProps, { children: _jsx(QueueSelect, { selectedQueue: selectedQueue, onSelect: setSelectedQueue, onToggle: handleToggle, status: FieldWrapper.getStatus(fieldWrapperProps.meta) }) })));
};
